import { type Theme } from "@mui/material";

interface StatusChipStyle {
  backgroundColor: string | undefined;
  color: string | undefined;
  borderColor: string | undefined;
}

export type ShiftStatusLabel = "Cancelled" | "Filled" | "Open";

export function getShiftStatusChipStyle(status: ShiftStatusLabel, theme: Theme): StatusChipStyle {
  const { statusChip } = theme.palette;

  const variant = (() => {
    switch (status) {
      case "Filled": {
        return statusChip?.success;
      }
      case "Cancelled": {
        return statusChip?.error;
      }
      case "Open": {
        return statusChip?.info;
      }
      default: {
        return statusChip?.muted;
      }
    }
  })();

  return {
    backgroundColor: variant?.background,
    color: variant?.text,
    borderColor: variant?.text,
  };
}
